import React, { useState } from 'react'

import { selectStacks } from 'redux/deck/selectors'
import { useAppSelector } from 'redux/hooks'

import ImageCard from 'components/card/deckCards/imageCard'
import StackWrapper from 'components/deckPage/dragAndDrop/StackWrapper'

import Select from 'components/formElements/SemanticSelect'

import styles from './pinnedCategory.module.scss'

const PinnedCategory = () => {
  const { mainDeck, sideDeck } = useAppSelector(selectStacks)
  const disableMargins = useAppSelector(state => state.cacheables.disableMargins)

  const mergedStacks = [...sideDeck, ...mainDeck]

  if (!sideDeck.find(stack => stack.name === 'Maybeboard'))
    mergedStacks.push({
      name: 'Maybeboard',
      cardIds: [],
      includedInDeck: false,
      price: 0,
      isPremier: false,
      includedInPrice: true,
      quantity: 0,
      mdfcQuantity: 0,
    })

  const defaultStack = 'Maybeboard'
  const options = mergedStacks.map(stack => ({ text: `${stack.name} (${stack.quantity})`, value: stack.name }))

  const [selectedStack, setSelectedStack] = useState(defaultStack)

  const stack = mergedStacks.find(s => s.name === selectedStack)

  return (
    <div className={`${styles.container} ${disableMargins ? styles.disableMargins : ''}`}>
      <Select options={options} value={selectedStack} onChange={setSelectedStack} />

      {stack && (
        <StackWrapper id="brewing-container" name={selectedStack} className={styles.stackWrapper}>
          <div className={styles.scrollContainer}>
            {stack.cardIds.map(cardId => (
              <ImageCard
                hidePrices
                stackName={stack.name}
                key={cardId}
                cardId={cardId}
                className={styles.card}
                basicCardClass={styles.basicCard}
                wrapperClassName={styles.wrapperClassName}
              />
            ))}
          </div>
        </StackWrapper>
      )}
    </div>
  )
}

export default PinnedCategory
